module.exports = __webpack_public_path__ + "static/media/bca.99f4f774.png";